export default __webpack_public_path__ + "media/vasVid.843fe80a.mp4";